import { NOTIFICATION_SETTINGS } from "../../constants/apis"
import { getUrl, replaceMultiple } from "../../utilities/helpers"

export const fetchNotificationSettings = (uuid, query) => (dispatch, getState, { apiReport }) => {
    const finalUrlPath = replaceMultiple(NOTIFICATION_SETTINGS, {
        "{{uuid}}": uuid,
    })
    const url = getUrl(finalUrlPath, query);
    return apiReport.get(url).then((result) => result).catch((error) => {
        throw error;
    })
}

export const updateNotificationSettings =(uuid, payload)=>(dispatch, getState,{apiReport})=>{
    const url = replaceMultiple(NOTIFICATION_SETTINGS,{
        "{{uuid}}":uuid,
    })
    return apiReport.put(url, payload).then((result)=>result).catch((error)=>{
        throw error;
    })
}